import { Dispatch, FC, SetStateAction } from 'react';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import Styles from './NonBookable.module.scss';
import Button from '@/components/UI/button/Button';
import SimilarProducts from '../_reusable/houseInfo/similarHousesContainer/similarProducts/SimilarProducts';
import Link from 'next/link';
const NonBookable: FC<{
  setOpen: Dispatch<SetStateAction<boolean>>;
}> = ({
  setOpen
}) => {
  return <>
      <Box className={Styles['non-bookable-container']} data-sentry-element="Box" data-sentry-source-file="NonBookable.tsx">
        <Box className={Styles['close-icon-container']} onClick={() => setOpen(false)} data-sentry-element="Box" data-sentry-source-file="NonBookable.tsx">
          <Icon type={'highEmphasis'} name={'close'} size={'large'} data-sentry-element="Icon" data-sentry-source-file="NonBookable.tsx" />
        </Box>
        <Box className={Styles['title-container']} data-sentry-element="Box" data-sentry-source-file="NonBookable.tsx">
          <Typography variant={'displayS_Bold'} color={'neutral_800'} data-sentry-element="Typography" data-sentry-source-file="NonBookable.tsx">
            این اقامتگاه غیر فعال شده است
          </Typography>
          <Link href={'/search'} className={Styles['button-container']} data-sentry-element="Link" data-sentry-source-file="NonBookable.tsx">
            <Button format={'outlined'} size={'large'} type="button" data-sentry-element="Button" data-sentry-source-file="NonBookable.tsx">
              بازگشت به صفحه جستجو
            </Button>
          </Link>
        </Box>
        <SimilarProducts bookableStatus="non_bookable" data-sentry-element="SimilarProducts" data-sentry-source-file="NonBookable.tsx" />
      </Box>
    </>;
};
export default NonBookable;